import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { ApiResponse } from '../services/httpService';

interface GetParams {
  skip?: number;
  take?: number;
  filter?: string;
  includeDeleted?: boolean;
}

interface InfiniteProp {
  query?: string;
  pageNumber: number;
  getMethod: (id: string, params: GetParams) => Promise<ApiResponse<unknown>>; // extends any array
  idProject?: string;
}

interface InfiniteScrollProp {
  result: unknown[];
  isLoading: boolean;
  isFetching: boolean;
  hasMore: boolean;
  error: ErrorRequest | null;
}

interface ErrorRequest {
  message: string;
  code?: number;
}

const paginationLength = 10;

export default function useLoadItems({
  query,
  pageNumber,
  idProject,
  getMethod,
}: InfiniteProp): InfiniteScrollProp {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isFetching, setIsFeching] = useState<boolean>(false);
  const [error, setError] = useState<ErrorRequest | null>(null); // null or object with status code and message
  const [result, setResult] = useState<unknown[]>([]);
  const [hasMore, setHasMore] = useState<boolean>(false);

  useEffect(() => {
    setResult([]);
  }, [query]);

  useEffect(() => {
    const loadData = async () => {
      setIsFeching(true);
      setError(null);
      try {
        if (idProject) {
          // why const data = getMethod(idProject...
          await getMethod(idProject, {
            take: paginationLength,
            skip: pageNumber * paginationLength,
            filter: query,
            includeDeleted: false,
          }).then((response) => {
            setResult((prev) => [...prev, ...response.items]);
            setHasMore(pageNumber * paginationLength < response.totalCount);
            setIsFeching(false);
          });
        }
      } catch (e) {
        const err = e as AxiosError;
        setError({ code: err.response?.status, message: err.message });
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, [query, pageNumber, idProject, getMethod]);

  return { result, isLoading, isFetching, hasMore, error };
}
